export default {
	page_title: 'Leaderboard',
};
